import { FormGroup, FormControl } from "@angular/forms";
import { TableHeader } from "./table-config";

export interface FilterInput {
    dbId: string; // database ID that is used to filter
    type: FilterType;
    placeholder: string;
    options?: FilterSelectOption[];
}

export enum FilterType {
    date = "date",
    select = "select",
    default = "default",
}

export interface FilterSelectOption {
    value: string;
    viewValue: string;
}

export function setFilterForm(
    tableHeaders: TableHeader[],
    filterControlForm: FormGroup
) {
    tableHeaders.forEach((header) => {
        filterControlForm.addControl(
            header.filterInput.dbId,
            new FormControl("")
        );
    });
}
